import React, { useState } from 'react';
import Container from '../../components/container/Container';
import Input from '../../components/questionnaire/Input';
import Client from '../../types/Client';
import db from '../../util/database';
import Tables from '../../util/tables';
import { useHistory } from 'react-router';
import Routes from '../../util/routes';
import { nowToMysqlFormat } from '../../util/date';

function LeftPanelComponent() {
  return (
    <div>Retour...</div>
  );
}

const createClient =() => {
  const client = new Client();
  client.id = Date.now();
  return client;
}

function CreateClient(props: { client?: Client }) {
  const [client, setClient] = useState<Client>(props.client || createClient());
  const history = useHistory();
  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setClient({ ...client, [name]: value });
  };
  const onSubmit = () => {
    if (client.nom || client.prenom) {
      const now = nowToMysqlFormat();
      const newClient = { ...client, created_at: now, updated_at: now };
      if (props.client) {
        db().collection(Tables.CLIENTS).doc({ id: props.client.id }).set(newClient);
      } else {
        db().collection(Tables.CLIENTS).add(newClient);
      }
      history.push(Routes.CHOOSE_CLIENT);
    } else {
      alert('le nom ou le prenom doivent etre remplis');
    }
  };
  console.log('[createclient] client:', client);
  return (
    <Container title="Clients" leftPanelComponent={<LeftPanelComponent />}>
      <div className="contact-wrap w-100 p-md-5 p-4">
        <h3 className="mb-4">Créer un client</h3>
        <div className="contactForm">
          <div className="row">
            <Input label="Id client" type="text" size="6" name="idclient" onChange={handleInputChange} />
            <Input label="email" type="text" size="6" name="email" onChange={handleInputChange} /> 
            <Input label="nom" type="text" size="6" name="nom" onChange={handleInputChange} /> 
            <Input label="prenom" type="text" size="6" name="prenom" onChange={handleInputChange} /> 
            <Input label="tel fixe" type="text" size="6" name="telf" onChange={handleInputChange} /> 
            <Input label="tel mobile" type="text" size="6" name="telm" onChange={handleInputChange} /> 
            <Input label="adresse1" type="text" size="6" name="adresse1" onChange={handleInputChange} /> 
            <Input label="adresse2" type="text" size="6" name="adresse2" onChange={handleInputChange} /> 
            <Input label="codepostal" type="text" size="6" name="codepostal" onChange={handleInputChange} /> 
            <Input label="ville" type="text" size="6" name="ville" onChange={handleInputChange} /> 
            <Input label="email agent" type="text" size="6" name="emailagent" onChange={handleInputChange} /> 
            <Input label="tel agent" type="text" size="6" name="telagent" onChange={handleInputChange} /> 
            <div className="col-md-12">
              <div className="form-group">
                <input type="submit" defaultValue="Send Message" className="btn btn-primary" onClick={onSubmit} />
                <div className="submitting" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default CreateClient;